<!-- <p-autoComplete autoHighlight="true" delay="500" field="item.name" placeholder="Search Vendor" [minLength]="1"
	[suggestions]="dropDownItems" [size]="30" forceSelection="true" (onSelect)="updateVendor($event)"
	(onClear)="deleteVendor($event)" (completeMethod)="filterCountrySingle($event)" [(ngModel)]="currentChoise"
	[ngModelOptions]="{standalone: true}" #customerCompleteInput>
	<ng-template let-choise pTemplate="item">
		<span *ngIf="choise.type === 'item'">{{choise.item.name}}</span>
	</ng-template>
</p-autoComplete> -->

<ng-container *ngIf="project.type?.name === 'InHouseFinishing' || project.type?.name === 'OrderFinishing'">
	<p-dropdown (onChange)="statusChange($event.value)" [options]="vendors" [(ngModel)]="vendor"
		placeholder="Select a Vendor" optionLabel="name"></p-dropdown>
</ng-container>